/**
 * Frontend service for calling Firebase Functions related to supplier APIs
 */

// Use the deployed Firebase Functions URL
const FUNCTIONS_BASE_URL = 'https://us-central1-apparel-logistics-447003-e318e.cloudfunctions.net';

/**
 * Compare prices for multiple order lines across suppliers
 * @param {Array} lines - Array of order line objects
 * @returns {Promise} Price comparison results
 */
export const comparePrices = async (lines) => {
  try {
    console.log('📞 Calling comparePrices Firebase Function...');
    
    const response = await fetch(`${FUNCTIONS_BASE_URL}/comparePrices`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ lines })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ comparePrices response:', data);
    
    return data;
  } catch (error) {
    console.error('❌ Error calling comparePrices:', error);
    throw error;
  }
};

/**
 * Test SanMar API connection (getPricing with a known test style)
 * @returns {Promise<{ success: boolean, message?: string, error?: string }>}
 */
export const testSanMarConnection = async () => {
  try {
    const response = await fetch(`${FUNCTIONS_BASE_URL}/testSanMarConnection`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({})
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP ${response.status}`);
    }

    return data;
  } catch (error) {
    console.error('SanMar connection test failed:', error);
    return {
      success: false,
      error: error.message || 'Connection test failed'
    };
  }
};

/**
 * Place orders with selected suppliers
 * @param {Array} lines - Array of order line objects with supplier selections
 * @returns {Promise} Order placement results
 */
export const placeOrders = async (lines) => {
  try {
    console.log('📞 Calling placeOrders Firebase Function...');
    
    const response = await fetch(`${FUNCTIONS_BASE_URL}/placeOrders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ lines })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`HTTP ${response.status}: ${errorText}`);
    }

    const data = await response.json();
    console.log('✅ placeOrders response:', data);
    
    return data;
  } catch (error) {
    console.error('❌ Error calling placeOrders:', error);
    throw error;
  }
};

